import { helper } from '@ember/component/helper';
import AttributeCondition from 'cio/app-models/conditions/attribute';
import { SerializedLegacyAttributeFilter } from 'cio/types/conditions/legacy-filter';
import { getFullAttributeValue } from 'cio/utils/conditions/attribute-value';

export function attributeConditionValue([condition]: [
  SerializedLegacyAttributeFilter | AttributeCondition | null,
]): string {
  if (condition == null) {
    return '';
  }
  return getFullAttributeValue(condition);
}

export default helper(attributeConditionValue);
